
import { isAllowedChannel } from '@/common/helpers/ModuleHelpers';
import { createNamespacedHelpers } from '@/common/vuex-composition-hooks';
import {
  IAuthActions,
  IAuthGetters,
  IAuthState,
  IChannel,
} from '@/modules/login/types';
import router from '@/router';
import { defineComponent, reactive, toRefs } from 'vue';
import * as vueRouter from 'vue-router';
import { IBrandManagerActions, IDashboardBrandManagementState } from '../types';
const Auth = createNamespacedHelpers<IAuthState, IAuthGetters, IAuthActions>(
  'auth'
);
import BaseIcon from '@/components/BaseIcon.vue';
import { firstUpperString } from '@/common/helpers/FirstUpperString';

const Dashboard = createNamespacedHelpers<
  IDashboardBrandManagementState,
  IBrandManagerActions
>('dashboardBrandManagement');

interface ITab {
  id?: number;
  index?: number;
  name?: string;
  fullname?: string;
  active?: boolean;
  code?: any;
  route?: string;
  module?: string;
}

interface State {
  brandtabs: ITab[];
  salesChannelTabs: ITab[];
  channelTabActive: any;
  allowedBrandTabs: any;
  allowedChannelTabs: any;
}

export default defineComponent({
  name: 'MobileTabs',
  components: {
    BaseIcon,
  },
  setup() {
    const { brands } = Auth.useState(['brands']);

    const { salesChannel } = Auth.useState(['salesChannel']);

    const { selectedchannel } = Dashboard.useState(['selectedchannel']);

    const { changeSelectedChannel } = Dashboard.useActions([
      'changeSelectedChannel',
    ]);

    const formatName = (name: string) => {
      return name[0].toUpperCase() + name.substring(1).toLowerCase();
    };

    const state: State = reactive<State>({
      brandtabs: [],
      salesChannelTabs: [],
      channelTabActive: '',
      allowedBrandTabs: [],
      allowedChannelTabs: [],
    });

    brands?.value?.forEach((el, index) => {
      state.brandtabs.push({
        id: index,
        name: formatName(el.name),
        active: false,
        code: el.name.toUpperCase(),
        module: '5',
        route: el.name.toUpperCase(),
      });
    });

    state.brandtabs.push({
      id: state.brandtabs.length + 1,
      name: 'Totais',
      active: false,
      code: 'TOTALS',
      module: '5',
      route: 'TOTALS',
    });

    salesChannel?.value?.forEach((el: IChannel) => {
      state.salesChannelTabs.push({
        id: el.id,
        name: firstUpperString(el.name),
        fullname:
          el.name == 'export' ? 'Exportação' : firstUpperString(el.name),
        active: false,
        code: el.code,
      });
    });

    state.allowedChannelTabs = state.salesChannelTabs.filter((tab: ITab) =>
      isAllowedChannel(tab.code)
    );

    const isActiveBrandTab = (pTabs) => {
      const route = vueRouter.useRoute();
      return pTabs.route === route.name;
    };

    state.allowedBrandTabs = state.brandtabs.filter((tab: ITab) => tab);

    const handleBrandTabChange = async (tabIndex: number) => {
      state.allowedBrandTabs.forEach((tab: ITab) => {
        tab.active = false;
      });

      const tab = state.allowedBrandTabs[tabIndex];

      if (tab) tab.active = true;

      await changeSelectedChannel(state.allowedChannelTabs[0]);

      await router.push({ name: tab?.route });
    };

    const handleChannelTabChange = async (tabIndex: number) => {
      state.allowedChannelTabs.forEach((tab: ITab) => {
        tab.active = false;
      });

      const tab = state.allowedChannelTabs[tabIndex];

      state.channelTabActive = tab;

      if (tab) tab.active = true;

      await router.push({ name: tab?.route });
    };

    return {
      ...toRefs(state),
      isActiveBrandTab,
      handleBrandTabChange,
      handleChannelTabChange,
      changeSelectedChannel,
      selectedchannel,
    };
  },

  mounted() {
    this.handleBrandTabChange(0);
  },

  methods: {
    changeChannel(channel: IChannel) {
      this.changeSelectedChannel(channel);
      this.handleChannelTabChange(channel.id);
    },
  },
});
